import { css } from 'styled-components';

export const focusRing = css`
  outline-offset: 1px;
  outline: 2px solid #00a4bd;
`;
